import getApi from "../api/getApi";
import postApi from "../api/postApi";
import * as url from "../api/url";

export const getLocationsByCompanyId = (companyID, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GETLOCATION_BY_COMPANYID}?companyId=${companyID}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getLocationsById = (companyID, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GET_LOCATION_BY_ID}?locationId=${companyID}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getLocationsType = (header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(url.GET_LOCATION_TYPE, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const saveLocation = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(url.SAVE_LOCATION, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
